import { PropsWithChildren } from 'react';
import { Flex } from './flex';

export function FormControls({ children }: PropsWithChildren) {
  return (
    <Flex color="text.secondary" gap={2} justifyContent="flex-end" px={3} pt={1.25} pb={2.25}>
      {children}
    </Flex>
  );
}
